import { render, staticRenderFns } from "./TrustpilotWidget.vue?vue&type=template&id=ce8789ac&scoped=true&"
import script from "./TrustpilotWidget.vue?vue&type=script&lang=js&"
export * from "./TrustpilotWidget.vue?vue&type=script&lang=js&"
import style0 from "./TrustpilotWidget.vue?vue&type=style&index=0&id=ce8789ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8789ac",
  null
  
)

export default component.exports